import { ReportingTemplate } from "models/reporting"
import { http } from "./http"

export const fetchReportingTemplates = async (_key: string) => {
  const { data } = await http
    .get("reports/template")
    .json<{ data: Omit<ReportingTemplate, "config">[] }>()
  return data
}

export const fetchReportingTemplate = async (id: string) => {
  const data = await http.get(`reports/template/${id}`).json()
  return data as ReportingTemplate
}

export const saveReportingTemplate = async (
  pld: Omit<ReportingTemplate, "id">,
) => {
  const json = pld
  const res = await http.post("reports/template/create", { json }).json()
  return res as ReportingTemplate[]
}

export const deleteReportingTemplate = async (id: string) => {
  return await http.delete(`reports/template/${id}`)
}
